module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp1_5010.1e243614.png";